<template>
  <div class="widget">
    <router-link tag="h3" class="widget-title mt-1" to="/user">
      <a>
        {{ $t("mi cuenta") }}
      </a>
    </router-link>
    <nav class="woocommerce-MyAccount-navigation">
      <ul>
        <router-link
          v-for="(item, n) in getterStMenu"
          :key="n"
          :tag="item.tag"
          :to="item.ruta"
          exact-active-class="is-active"
        >
          <a> {{ $t(item.texto) }} </a>
        </router-link>
        <li>
          <a href="#" v-on:click="logout">
            {{ $t("salir") }}
            <i class="fa fa-sign-out"></i>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "Usermenuside",
  data: () => ({}),
  methods: {
    ...mapActions("account", ["logout"]),
  },
  computed: {
    ...mapGetters("menu", ["getterStMenu"]),
  },
};
</script>
